export default __webpack_public_path__ + "static/media/flag-saint-kitts-and-nevis.da3dfcf9.svg";